import React from 'react';

export default function SectionHeader(props) {

    const styles = props.withOffset
        ? { marginTop: '20px', marginBottom: '20px', marginLeft: '-15px' }
        : { marginBottom: '20px' };

    return (
        <div style={{ borderBottom: '1px solid #b7b7bd', ...styles, ...(props.style || {}) }}>
            <h4><strong>{props.title}</strong></h4>
        </div>
    );
}
